import Full from 'Container/Full'

// component
const Email = () => import('Views/email/Email')

// helpers
import {
  checkAuthorization,
  checkIp,
  checkCompanySettingsRoute,
} from '../helpers/helpers.js'

export default {
  path: '/email',
  component: Full,
  meta: { requiresAuth: true },
  beforeEnter(to, from, next) {
    checkAuthorization(next)
    checkIp(next)
    next()
  },
  children: [
    {
      path: '',
      component: Email,
      name: 'email',
      meta: { title: 'メール取込結果' },
    },
  ],
}
